import * as Yup from 'yup';

import i18n from '@/i18n';

export const personalDetailsValidationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required(i18n.t('firstNameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    lastName: Yup.string()
      .required(i18n.t('lastNameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    email: Yup.string().required(i18n.t('emailRequired', { ns: 'common' }))
      .email(i18n.t('emailInvalid', { ns: 'common' })),
  });
